import React from 'react';
import PropTypes from 'prop-types';
import withProfile from 'hocs/withProfile';

import RewardModal from 'admin-moderator/containers/RewardModal';

import { ReactComponent as Ruble } from 'icons/Ruble.svg';

import Button from './Button';

export class Reward extends React.PureComponent {
  state = {
    isRewardModalOpen: false,
  }

  handleClick = () => {
    this.setState({ isRewardModalOpen: true });
  }

  handleRewardModalClose = () => {
    this.setState({ isRewardModalOpen: false });
  }

  render() {
    if (!this.props.can({
      permission: 'remuneration',
      resource: 'users',
    })) return null;

    return (
      <React.Fragment>
        <Button
          type="button"
          onClick={this.handleClick}
        >
          <Ruble />
        </Button>

        {this.state.isRewardModalOpen && (
          <RewardModal
            id={this.props.id}
            onClose={this.handleRewardModalClose}
            onReward={this.props.onReward}
          />
        )}
      </React.Fragment>
    );
  }
}

Reward.propTypes = {
  id: PropTypes.string.isRequired,
  can: PropTypes.func,
  profile: PropTypes.shape({ id: PropTypes.string }),
  onReward: PropTypes.func,
};

Reward.defaultProps = {
  profile: {},
  can: () => {},
  onReward: () => {},
};

export default withProfile(Reward);
